var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.16,75.79l-15.57-15.57c3.32-4.44,5.29-9.94,5.29-15.91,0-14.68-11.9-26.58-26.57-26.58s-26.58,11.9-26.58,26.58,11.9,26.57,26.58,26.57c5.97,0,11.48-1.97,15.91-5.29l15.57,15.57c1.48,1.48,3.89,1.48,5.37,0,1.48-1.48,1.48-3.89,0-5.37ZM25.32,44.31c0-10.49,8.5-18.99,18.99-18.99s18.98,8.5,18.98,18.99-8.5,18.98-18.98,18.98-18.99-8.5-18.99-18.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeZoom);
export default __webpack_public_path__ + "static/media/acae_zoom.0403d3d5.svg";
export { ForwardRef as ReactComponent };